export default "__VITE_PUBLIC_ASSET__6330d17c__"